module.exports = __webpack_public_path__ + "static/img/tcqn9.8f90d91.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newestqianniu/tcqn9.png
// module id = 1392
// module chunks = 0